import { Controller } from "@hotwired/stimulus";

export function applyDependentFieldVisibility(field, controllingField) {
  const requiredField = field.dataset.requiredField;
  const expectedValue = field.dataset.expectedValue;
  const checkbox = controllingField.querySelector('input[type="checkbox"]');
  if (!checkbox) return;

  const isVisible = checkbox.checked.toString() === expectedValue;
  const wasHidden = field.classList.contains("hidden");
  field.classList.toggle("hidden", !isVisible);

  field
    .querySelectorAll("input:not([type='hidden']), select, textarea")
    .forEach((input) => {
      if (isVisible) {
        input.required = requiredField === "true";

        if (wasHidden) {
          if (input.type === "checkbox" || input.type === "radio") {
            input.checked = false;
          } else {
            input.value = "";
          }
        }
      } else {
        input.required = false;

        if (!wasHidden) {
          const hiddenValue = field.dataset.hiddenValue;
          if (input.type === "checkbox") {
            input.checked = hiddenValue === "true";
          } else {
            input.value = hiddenValue;
          }
        }
      }
    });
}

// Connects to data-controller="route-datapoints--dependency-fields"
export default class extends Controller {
  static targets = ["fieldContainer", "dependentField"];

  connect() {
    this.updateDependentFields();
  }

  fieldChanged(event) {
    // Ensure we're only responding to checkbox changes
    if (event.target.type !== "checkbox") return;

    const fieldContainer = event.target.closest("[data-field-id]");
    if (!fieldContainer) return;

    this.updateDependentFields();
  }

  updateDependentFields() {
    this.dependentFieldTargets.forEach((field) => {
      const dependentOn = field.dataset.dependentOn;
      const controllingField = this.fieldContainerTargets.find(
        (f) => f.dataset.fieldId === dependentOn
      );

      if (!controllingField) return;

      applyDependentFieldVisibility(field, controllingField);
    });
  }
}
